/**
 * @generated SignedSource<<c886f9e61f468b72ae7e4ecb4e3fca11>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type ProductMembershipsExportCsvButtonFragment$data = {
  readonly id: string;
  readonly " $fragmentType": "ProductMembershipsExportCsvButtonFragment";
};
export type ProductMembershipsExportCsvButtonFragment$key = {
  readonly " $data"?: ProductMembershipsExportCsvButtonFragment$data;
  readonly " $fragmentSpreads": FragmentRefs<"ProductMembershipsExportCsvButtonFragment">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "ProductMembershipsExportCsvButtonFragment",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    }
  ],
  "type": "Product",
  "abstractKey": null
};

(node as any).hash = "cd25923c9e6424c4dd4337c7800910d6";

export default node;
